export enum CheckBoxSize {
  Large = 'large',
  Medium = 'medium',
  Small = 'small',
  // 콘텐츠홈에서 먼저들어가는 체크박스를 대응하기 위한 타입입니다.
  ContentHome = 'contentHome',
  /**
   * 서브탭 sorting, filtering 전용
   * https://www.figma.com/file/H0ZN9tCOnE1jGLQr56V1S4/%EC%9D%B4%EA%B4%80%EC%A4%91_NEXT_%EC%B5%9C%EC%A2%85-%EC%B7%A8%ED%95%A9_APP%26WEB?type=design&node-id=2892-58595&mode=design&t=eoltCWc1EzwASaAh-0
   */
  SubTab = 'subTab',
}
